var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32 0C1.93413 0 0 1.93413 0 4.32V31.68C0 34.0659 1.93413 36 4.32 36H31.68C34.0659 36 36 34.0659 36 31.68V4.32C36 1.93413 34.0659 0 31.68 0H4.32ZM10.7932 26.8209C11.1505 27 11.3291 27 11.6864 27C12.0437 27 12.2223 27 12.5796 26.8209L25.0845 19.6567C25.6204 19.2985 25.9777 18.7612 25.9777 18.0448C25.9777 17.3284 25.6204 16.791 25.0845 16.4328L12.5796 9.26866C12.0437 8.91045 11.3291 8.91045 10.7932 9.26866C10.2573 9.62687 9.9 10.1642 9.9 10.8806V25.209C9.9 25.9254 10.2573 26.4627 10.7932 26.8209ZM20.6184 18.0448L13.4728 22.1642V13.9254L20.6184 18.0448Z",
    fill: "#FBB979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.e3bf7d1663dd830004e2202deb2c2da1.svg";
export { ForwardRef as ReactComponent };